import { makeAutoObservable } from 'mobx';
import SessionStore from './session';
import { Http } from './http';

export interface SalesByMonth {
    month: string;
    label: string;
    total: number;
    count: number;
}

export interface SalesByCustomer {
    email: string;
    name: string;
    order_count: number;
    total: number;
}

export interface SalesByProduct {
    name: string;
    quantity: number;
    order_count: number;
}

export default class SalesStore {
    byMonth: SalesByMonth[] = [];
    byCustomer: SalesByCustomer[] = [];
    byProduct: SalesByProduct[] = [];
    isLoading = false;

    private http: Http;

    constructor(sessionStore: SessionStore) {
        makeAutoObservable(this);
        this.http = new Http(sessionStore);
    }

    fetchByMonth = async () => {
        this.isLoading = true;
        const { data, successful } = await this.http.getApi<SalesByMonth[]>('sales/by-month');
        if (successful && data) {
            this.byMonth = data;
        }
        this.isLoading = false;
    };

    fetchByCustomer = async () => {
        this.isLoading = true;
        const { data, successful } = await this.http.getApi<SalesByCustomer[]>('sales/by-customer');
        if (successful && data) {
            this.byCustomer = data;
        }
        this.isLoading = false;
    };

    fetchByProduct = async () => {
        this.isLoading = true;
        const { data, successful } = await this.http.getApi<SalesByProduct[]>('sales/by-product');
        if (successful && data) {
            this.byProduct = data;
        }
        this.isLoading = false;
    };
}